import React, { useMemo, useState } from 'react';
import objectPath from 'object-path';
import { useHtmlClassService } from '../../_core/MetronicLayout';
import { QuickUserToggler } from '../extras/QuiclUserToggler';
import { IconButton, useMediaQuery, Paper } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import InputBase from '@material-ui/core/InputBase';
import SearchIcon from '@material-ui/icons/Search';
import { useHistory } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
	root: {
		padding: '2px 4px',
		display: 'flex',
		alignItems: 'center',
		width: 310,
	},
	input: {
		marginLeft: theme.spacing(1),
		flex: 1,
	},
	iconButton: {
		padding: 10,
	},
	divider: {
		height: 28,
		margin: 4,
	},
}));

export function Topbar() {
	const classes = useStyles();
	const history = useHistory();
	const uiService = useHtmlClassService();
	const filial = localStorage.getItem('type');
	const [inputSearch, setInputSearch] = useState('');
	const isMobile = useMediaQuery('(max-width: 768px)');

	const layoutProps = useMemo(() => {
		return {
			viewUserDisplay: objectPath.get(uiService.config, 'extras.user.display'),
		};
	}, [uiService]);

	const goToResultView = (searchParam) => {
		if (searchParam) {
			history.push(`/busqueda-general/resultados?s=${searchParam}`);
		}
	};

	return (
		<div
			className="topbar d-flex justify-content-between align-center w-100"
			style={{ height: isMobile && 75 }}
		>
			<div className="d-flex align-items-center">
				{!filial && <h2 className="font-weight-bold text-danger">SAOC</h2>}
			</div>
			{filial === null ? (
				<div className="d-flex align-items-center input-query">
					<Paper className={`${classes.root} `}>
						<InputBase
							className={`${classes.input} input-query`}
							placeholder="Búsqueda General"
							onKeyPress={(e) => {
								if (e.key === 'Enter') {
									goToResultView(inputSearch);
								}
							}}
							inputProps={{ 'aria-label': 'busqueda general' }}
							onChange={(e) => setInputSearch(e.target.value)}
						/>
						<IconButton
							className={classes.iconButton}
							onClick={() => goToResultView(inputSearch)}
						>
							<SearchIcon />
						</IconButton>
					</Paper>
				</div>
			) : (
				'  '
			)}
			<div className="d-flex align-items-center">
				{layoutProps.viewUserDisplay && <QuickUserToggler />}
			</div>
		</div>
	);
}
